import { SERVER_URL, CDN_URL } from '../js/config.js';

export const R2Config = {
  paths: {
    characters: {
      imagesBaseUrl: '/data/characters/images/',
      rankings: '/data/characters/characters_rankings.json',
      modal: '/data/characters/characters_rankings_modal.json',
      tags: '/data/characters/tags/'
    }
  },

  cache: {
    maxAge: 3600000, // 1 hour
    dbName: 'kissandra-r2-cache',
    dbVersion: 6,
    stores: {
      characters: 'characters',
      characterDetails: 'character-details',
      scenarios: 'scenarios',
      tagMappings: 'tag-mappings',
      scenarioImages: 'scenarioImages',
      imageUrls: 'imageUrls',
      locations: 'locations'
    }
  },

  api: {
    enableFallback: true,
    baseUrl: SERVER_URL,
    endpoints: {
      characters: '/api/v1/characters/rankings',
      characterDetails: '/api/v1/characters'
    }
  }
};

export const R2Helpers = {
  getCharacterImageUrl(characterId, type) {
    return `${CDN_URL}${R2Config.paths.characters.imagesBaseUrl}${characterId}_${type}.webp`;
  }
};